import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { Sparkles } from '@/features/adviser-chat/components/Sparkles'

interface ConversationNotFoundProps {
  onNewConversation: () => void
}

export const ConversationNotFound = ({
  onNewConversation,
}: ConversationNotFoundProps) => (
  <div
    role="status"
    className="flex flex-col items-center justify-center flex-1 gap-3 px-6 text-center"
  >
    <Sparkles className="mb-2" />
    <Text variant={TypographyStyles.H3}>
      We couldn&apos;t find that conversation
    </Text>
    <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
      It may have been deleted, or the link may be wrong.
    </Text>
    <Button
      variant="secondary"
      size="sm"
      iconLeft={faPlus}
      onClick={onNewConversation}
      className="mt-2"
    >
      New conversation
    </Button>
  </div>
)
